<script setup lang="ts">
import {ref} from "vue";

const replyContent = ref("");
const visible = ref(false)

const show = () => {
  replyContent.value = ""
  visible.value = true
}

const hide = () => {
  visible.value = false
}

const emit = defineEmits(["onSubmit"])

const onSubmit = () => {
  emit("onSubmit", replyContent.value)
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog width="40rem" title="回复评价" align-center v-model="visible" :close-on-click-modal="true">
    <el-input type="textarea" v-model="replyContent" placeholder="请输入回复内容" />
    <el-button type="primary" @click="onSubmit" class="mt-1rem">回复</el-button>
  </el-dialog>
</template>

<style scoped>
</style>
